import ROL from "./accordion/ROL";
import Selic from "./accordion/Selic";
import Anexo2 from "./accordion/Anexo2";
import Anexo6_1 from "./accordion/Anexo6_1";
import Anexo6_2 from "./accordion/Anexo6_2";
import ProjetoRN219 from "./accordion/ProjetoRN219";
import ProjetoRN316 from "./accordion/ProjetoRN316";

import ApiService from "@/common/api/api.service";

const MovimentacaoFinanceira = {

    listarRol : ROL.listar,
    salvarRol : ROL.salvar,
    deletarRol : ROL.deletar,
    salvarReceita : ROL.salvarReceita,
    removerReceita : ROL.removerReceita,
    salvarDeducao : ROL.salvarDeducao,
    removerDeducao : ROL.removerDeducao,

    listarSelic : Selic.listar,
    salvarSelic : Selic.salvar,
    deletarSelic : Selic.deletar,
    buscarFatorAcumulado : Selic.buscarFatorAcumulado,

    listarValoresDebitados : Anexo2.listarValoresDebitados,
    listarProjetos : Anexo2.listarProjetos,
    salvarValoresDebitados : Anexo2.salvar,
    deletarValoresDebitados : Anexo2.deletar,
    listarAnexo2 : Anexo2.listar,

    listarAnexo6_1 : Anexo6_1.listar,
    salvarBaixas : Anexo6_1.salvarBaixas,

    listarAnexo6_2 : Anexo6_2.listar,
    salvarAnexo6_2 : Anexo6_2.salvar,
    
    buscarProjetoRN219 : ProjetoRN219.buscar,
    listarProjetosRN219 : ProjetoRN219.listar,
    salvarProjetoRN219 : ProjetoRN219.salvar,
    salvarDesembolsoRN219 : ProjetoRN219.salvarDesembolso,
    excluirDesembolsoRN219 : ProjetoRN219.excluirDesembolso,
    downloadDesembolsoRN219 : ProjetoRN219.downloadDesembolso,
    salvarCustoRN219 : ProjetoRN219.salvarCusto,
    excluirCustoRN219 : ProjetoRN219.excluirCusto,
    downloadCustoRN219 : ProjetoRN219.downloadCusto,

    buscarProjetoRN316 : ProjetoRN316.buscar,
    listarProjetosRN316 : ProjetoRN316.listar,
    salvarProjetoRN316 : ProjetoRN316.salvar,
    salvarDesembolsoRN316 : ProjetoRN316.salvarDesembolso,
    excluirDesembolsoRN316 : ProjetoRN316.excluirDesembolso,
    downloadDesembolsoRN316 : ProjetoRN316.downloadDesembolso,
    salvarCustoRN316 : ProjetoRN316.salvarCusto,
    excluirCustoRN316 : ProjetoRN316.excluirCusto,
    downloadCustoRN316 : ProjetoRN316.downloadCusto,

    listarGrafico : function(empresaId, ano, anoFim, mesInicio, mesFim, ) {
        return ApiService.get(`GraficoMovimentacaoFinanceira?Ano=${ano}${anoFim ? `&AnoFim=${anoFim}` : ''}${mesInicio ? `&MesInicio=${mesInicio}` : ''}${mesFim ? `&MesFim=${mesFim}`: ''}&EmpresaId=${empresaId}`);
    },

    buscarProjetosRN219 : function(filtro){
        return ApiService.get(`Anexo2/projetos-rn219?Ano=${filtro.ano}&mes=${filtro.mes}&empresaId=${filtro.empresaId}`);
    },
    buscarProjetos : function(filtro){
        return ApiService.get(`Anexo2/projetos?Ano=${filtro.ano}&mes=${filtro.mes}&empresaId=${filtro.empresaId}`);
    }

};

export default MovimentacaoFinanceira;
